var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompleteicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    rx: 23,
    fill: "#70A1E5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9091 27.5374C21.7349 27.5374 21.5608 27.4733 21.4233 27.3358L20.0483 25.9608C19.7824 25.6949 19.7824 25.2549 20.0483 24.9891C20.3141 24.7233 20.7541 24.7233 21.0199 24.9891L21.9091 25.8783L25.0899 22.6974C25.3558 22.4316 25.7958 22.4316 26.0616 22.6974C26.3274 22.9633 26.3274 23.4033 26.0616 23.6691L22.3949 27.3358C22.2666 27.4733 22.0833 27.5374 21.9091 27.5374Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8333 18.1874H21.1666C20.2866 18.1874 18.6458 18.1874 18.6458 15.6666C18.6458 13.1458 20.2866 13.1458 21.1666 13.1458H24.8333C25.7133 13.1458 27.3541 13.1458 27.3541 15.6666C27.3541 16.5466 27.3541 18.1874 24.8333 18.1874ZM21.1666 14.5208C20.2591 14.5208 20.0208 14.5208 20.0208 15.6666C20.0208 16.8124 20.2591 16.8124 21.1666 16.8124H24.8333C25.9791 16.8124 25.9791 16.5741 25.9791 15.6666C25.9791 14.5208 25.7408 14.5208 24.8333 14.5208H21.1666Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.75 32.8541H20.25C15.0983 32.8541 14.0625 30.4891 14.0625 26.6666V21.1666C14.0625 16.9866 15.575 15.1991 19.2967 15.0066C19.6725 14.9882 20.0025 15.2724 20.0208 15.6574C20.0392 16.0424 19.7458 16.3541 19.37 16.3724C16.7667 16.5191 15.4375 17.2982 15.4375 21.1666V26.6666C15.4375 30.0582 16.1067 31.4791 20.25 31.4791H25.75C29.8933 31.4791 30.5625 30.0582 30.5625 26.6666V21.1666C30.5625 17.2982 29.2333 16.5191 26.63 16.3724C26.2542 16.3541 25.9608 16.0241 25.9792 15.6482C25.9975 15.2724 26.3183 14.9791 26.7033 14.9974C30.425 15.1991 31.9375 16.9866 31.9375 21.1574V26.6574C31.9375 30.4891 30.9017 32.8541 25.75 32.8541Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompleteicon);
export default __webpack_public_path__ + "static/media/completeicon.6929dd846ccb918fe56edd9f6488a4a0.svg";
export { ForwardRef as ReactComponent };